import { render } from "./RequestPositionsModal.vue?vue&type=template&id=292f976b&scoped=true"
import script from "./RequestPositionsModal.vue?vue&type=script&lang=js"
export * from "./RequestPositionsModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292f976b"]])

export default __exports__